import { useCallback, useEffect } from 'react';

import { useScreenMessage } from '@gogame/screens';
import { useSocket } from '@gogame/sockets';

import { EVENT_RESTORE_PLAN } from '../constants';

export const useSocketRestore = () => {
  const socket = useSocket();
  const { showMessage } = useScreenMessage();

  const handleDraftPlan = useCallback(({ viewVersion, user }) => {
    let textPrefix = `Plan was restored`;
    if (user) {
      textPrefix += ` by ${user?.login}`;
    }
    showMessage(`${textPrefix} to ${viewVersion}`, {
      ttl: 6000,
    });
  }, []);

  useEffect(() => {
    socket.on(EVENT_RESTORE_PLAN, handleDraftPlan);
    return () => {
      socket.off(EVENT_RESTORE_PLAN, handleDraftPlan);
    };
  }, [socket, handleDraftPlan]);
};
